// Girişte bir kez açılan hatırlatma penceresi
const loginReminders = {
  title: 'Bekleyen işleriniz var',
  subtitle_one: 'İlgilenmeniz gereken bir konu var.',
  subtitle_other: 'İlgilenmeniz gereken {{count}} konu var.',
  later: 'Daha sonra',
  sops: {
    title: 'Okunmamış SOP’lar',
    description: 'Okundu olarak işaretlediğiniz SOP’lar bu listeden çıkar.',
    action: 'SOP’lara git',
    more_one: '+{{count}} SOP daha',
    more_other: '+{{count}} SOP daha',
  },
  docs: {
    title: 'Eksik belgeler',
    description: 'Profilinizdeki CV/GCP/IATA bölümünden yükleyebilirsiniz.',
    action: 'Belgelerimi yükle',
    notUploaded: 'Yüklenmedi',
  },
  cargo: {
    title: 'Kargonuz var',
    description: 'Henüz teslim edilmemiş kargolarınız. Durumunu Profil › Kargolarım’dan güncelleyebilirsiniz.',
    action: 'Kargolarıma git',
    more_one: '+{{count}} kargo daha',
    more_other: '+{{count}} kargo daha',
    overdue: 'Gecikti',
    expected: 'Beklenen: {{date}}',
  },
};

export default loginReminders;
